import { Navigate, useLocation } from "react-router-dom";
import { isTokenExpired } from "../modules/common/ts/CommonFunctions";

function PrivateRoute({ children }: { children: JSX.Element }) {
    const isLogin = !isTokenExpired(localStorage.getItem("accessToken") || "")

    let location = useLocation();
    if (!isLogin) {
        return <Navigate to="/" replace state={{ from: location }} />
    }

    return children;
}

export default PrivateRoute;
